import { render, staticRenderFns } from "./BuyTabs.vue?vue&type=template&id=70eb56a0&scoped=true&"
import script from "./BuyTabs.vue?vue&type=script&lang=js&"
export * from "./BuyTabs.vue?vue&type=script&lang=js&"
import style0 from "./BuyTabs.vue?vue&type=style&index=0&id=70eb56a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eb56a0",
  null
  
)

export default component.exports